import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_wall_decor: FaireCategoryEntity = {
  token: "catalog_cat_wall-decor",
  type: "category",
  name: "Wall decor",
  count: 427,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
